import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import Checkbox from "components/DesignComponents/Checkbox";
import { getAllPermissions, PERMISSION_GROUP_ARRAY } from "context/auth";

import { getPermissionCheckState } from "../functions";
import SinglePermissionGroup from "./SinglePermissionGroup";
import { PermissionListProps } from "./types";

const PermissionList = ({
    checkedPermissions,
    isLocalPermissionCheck,
    handlePermissionCheck
}: PermissionListProps) => {
    const { gray200 } = colors;

    const { t } = useTranslation();

    const allPermissions = getAllPermissions();

    const { isAll, isPartial, isNone } = getPermissionCheckState(
        allPermissions,
        checkedPermissions
    );

    const toggleAllPermissionCheck = () => {
        const updatedPermissions = isNone ? allPermissions : checkedPermissions;
        handlePermissionCheck(updatedPermissions);
    };

    return (
        <div
            css={css({
                border: `1px solid ${gray200}`,
                borderRadius: "8px"
            })}
        >
            <div
                css={css({
                    boxShadow: "0 -1px 0 0 #E2E8F0 inset",
                    padding: "12px 24px 12px 18px"
                })}
            >
                <Checkbox
                    label={t("Dialog##all permissions")}
                    info={t("Dialog##manage permissions")}
                    checked={isAll}
                    indeterminate={isPartial}
                    onChange={toggleAllPermissionCheck}
                />
            </div>

            {PERMISSION_GROUP_ARRAY.map((permissionGroup, index, list) => {
                const allGroupPermissions = permissionGroup.permissions;

                const groupCheckedPermissions = checkedPermissions.filter(
                    checkedPerm => allGroupPermissions.includes(checkedPerm)
                );

                return (
                    <SinglePermissionGroup
                        key={permissionGroup.groupId}
                        permissionGroup={permissionGroup}
                        checkedPermissions={groupCheckedPermissions}
                        isLocalPermissionCheck={isLocalPermissionCheck}
                        hasNoBoxShadow={index === list.length - 1}
                        togglePermissionCheck={handlePermissionCheck}
                    />
                );
            })}
        </div>
    );
};

export default PermissionList;
